import { HELP_ITEM_ID, HELP_ITEM_URLS } from '@common/components/HelpMenu'

import { usePortalOnboardingStore } from '@apps/portal-onboarding/stores/portal-onboarding.store'

type CreateHelpClickHandlerParams = {
  setFeedbackPopoverOpen: (open: boolean) => void
}

export function createHelpClickHandler({ setFeedbackPopoverOpen }: CreateHelpClickHandlerParams) {
  return (itemId: string) => {
    if (itemId === HELP_ITEM_ID.PORTAL_ONBOARDING) {
      usePortalOnboardingStore.getState().openWelcome()
      return
    }

    if (itemId === HELP_ITEM_ID.SHARE_FEEDBACK) {
      if (typeof window !== 'undefined') {
        window.requestAnimationFrame(() => setFeedbackPopoverOpen(true))
      } else {
        setFeedbackPopoverOpen(true)
      }
      return
    }

    const url = HELP_ITEM_URLS[itemId]
    if (url && typeof window !== 'undefined') {
      window.open(url, '_blank', 'noopener,noreferrer')
      return
    }

    // TODO: implement Keyboard shortcuts modal
  }
}
